export default __webpack_public_path__ + "static/illustration-6-c92371b6e2305842476c2443902d30dd.png";